import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_SET_MAKING_LOGIN,
  AUTH_SET_USER,
  AUTH_WITH_ERROR,
  MAKE_LOGIN,
  UPDATE_FLAG_MAKING_LOGIN
} from './types';
import { features } from './constants';
import { defaultAuthenticationState } from '@/store/modules/authentication/state';
import { payloadAuthSetUser } from '@/store/modules/authentication/mutations';
import axios, { AxiosResponse } from 'axios';
import { httpService } from '@/services';
import { CONFIG } from '@/config';
import qs from 'qs';
import {getCountryAcronym} from '@/enums/country.enum';

export interface userBasicInfo {
  username: string;
  email: string;
}

export interface payloadLogin extends userBasicInfo {
  token: string;
}

export interface payloadMakeLogin {
  email: string;
  password: string;
}

const getFeatures = (commit: any, obj: payloadLogin, callback: () => void = () => {}): void => {
  const urlFeatures = `${CONFIG.URL.NEODASH_API}/api/neodash/user/info`;
  const afterAll = info => {
    const userData: payloadAuthSetUser = {
      ...obj,
      userFullName: info.fullName,
      idClient: info.client,
      idVehicleType: info.vehicleType,
      features: info.functionality.map(x => x.userInterfaceId),
      country: getCountryAcronym(info.country)
    };

    commit(AUTH_SET_USER, userData);
    commit(AUTH_WITH_ERROR, false);
    callback();
  };

  httpService.http.get(urlFeatures)
  .then(x => afterAll(x.data));
};

export const actions = {
  [AUTH_LOGIN]: ({ commit }, payload: payloadLogin) => {
    getFeatures(commit, payload);
  },

  [AUTH_LOGOUT]: ({ commit }) => {
    commit(AUTH_SET_USER, defaultAuthenticationState);
  },

  [MAKE_LOGIN]: ({ commit }, payload: payloadMakeLogin) => {
    const urlLogin = `${CONFIG.URL.NEOGIG_API}/token`;

    commit(AUTH_SET_MAKING_LOGIN, true);
    axios
      .post(
        urlLogin,
        qs.stringify({
          username: payload.email,
          password: payload.password,
          grant_type: 'password'
        })
      )
      .then((res: AxiosResponse) => {
        const obj: payloadLogin = {
          username: res.data.username,
          email: res.data.username,
          token: res.data.access_token
        };
        getFeatures(commit, obj, () => this.$router.go(this.$route as any));
      })
      .catch(err => {
        console.error(err);
        commit(AUTH_WITH_ERROR, true);
      });
  },

  [UPDATE_FLAG_MAKING_LOGIN]: ({ commit }, payload: boolean) => {
    commit(AUTH_SET_MAKING_LOGIN, !!payload);
  }
};
